import { useState } from 'react';
import { JOBS } from '../data';

export default function Experience() {
  const [active, setActive] = useState(0);
  const job = JOBS[active];

  return (
    <section id="experience" className="relative z-10 py-24 px-5 sm:px-8 bg-bg">
      <div className="max-w-5xl mx-auto">
        <div className="mb-12">
          <span className="section-tag bg-cyan/10 border border-cyan/22 text-cyan">{`// EXPERIENCE`}</span>
          <h2 className="font-display font-extrabold tracking-tight" style={{ fontSize: 'clamp(28px,4vw,46px)' }}>
            Where I've <span className="text-cyan">shipped work</span>
          </h2>
        </div>

        <div className="flex flex-col lg:grid lg:grid-cols-[260px,1fr] gap-5">

          {/* Tab list — horizontal scroll on mobile */}
          <div className="flex flex-row lg:flex-col gap-2 overflow-x-auto lg:overflow-visible pb-1 lg:pb-0">
            {JOBS.map((j, i) => {
              const isActive = i === active;
              return (
                <button
                  key={i}
                  onClick={() => setActive(i)}
                  className={`flex items-start gap-2.5 p-3.5 rounded-xl text-left cursor-pointer transition-all duration-200
                              flex-shrink-0 lg:flex-shrink w-[220px] lg:w-auto border
                              ${isActive ? 'bg-surf2' : 'bg-surf hover:bg-surf2'}`}
                  style={{
                    borderColor: isActive ? j.color + '55' : '#1e2d47',
                    borderLeftWidth: 3,
                    borderLeftColor: j.color,
                  }}>
                  <span className="text-lg flex-shrink-0 mt-0.5">{j.icon}</span>
                  <div>
                    <div className="text-xs font-bold" style={{ color: isActive ? j.color : '#E2E8F0' }}>
                      {j.company}
                    </div>
                    <div className="font-mono text-[10px] text-tx3 mt-1">{j.period}</div>
                    <span className="inline-block mt-1.5 font-mono text-[9px] rounded px-1.5 py-0.5"
                          style={{ color: j.color, background: j.color + '18', border: `1px solid ${j.color}33` }}>
                      {j.type}
                    </span>
                  </div>
                </button>
              );
            })}
          </div>

          {/* Detail */}
          <div key={active} className="bg-surf border border-bord rounded-2xl p-6 sm:p-7 border-t-[3px]"
               style={{ borderTopColor: job.color, animation: 'fadeUp .35s ease both' }}>
            <div className="mb-6">
              <h3 className="font-display text-xl sm:text-2xl font-extrabold text-tx mb-1">{job.role}</h3>
              <div className="text-sm font-semibold mb-1" style={{ color: job.color }}>{job.company}</div>
              <div className="font-mono text-[11px] text-tx3">{job.location} · {job.period}</div>
            </div>
            <div className="flex flex-col gap-2.5 mb-5">
              {job.highlights.map((h, i) => (
                <div key={i} className="flex gap-3 p-3 bg-surf2 border border-bord rounded-xl items-start">
                  <span className="text-sm flex-shrink-0 mt-0.5">{h.icon}</span>
                  <span className="text-sm text-tx2 leading-relaxed">{h.text}</span>
                </div>
              ))}
            </div>
            <div className="pt-4 border-t border-bord">
              <div className="font-mono text-[9px] text-tx3 uppercase tracking-[1.5px] mb-2.5">Tech Used</div>
              <div className="flex flex-wrap gap-1.5">
                {job.tech.map(t => (
                  <span key={t} className="font-mono text-[10px] text-tx2 bg-surf2 border border-bord2 rounded-md px-2 py-0.5">
                    {t}
                  </span>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
